// Turns the state of an explored chart into a plain-language question for the
// agent, so a user who has drilled somewhere interesting can hand that exact
// view back to the chat instead of describing it themselves.
//
// Kept pure (and separate from the modal) so the wording is unit-testable — the
// agent's answer quality depends on this string naming the query shape
// precisely enough that it re-runs the same aggregation rather than guessing.
const buildAskAboutViewQuestion = ({
  chartTitle,
  breakdownLabel,
  trendInterval,
  startDate,
  endDate,
  filterDescriptions,
}: {
  chartTitle?: string;
  // The dimension the chart groups by, in business language (e.g. "Region").
  breakdownLabel?: string;
  // The trend bucket, when the chart is over time (e.g. "month").
  trendInterval?: string;
  // Always concrete ISO dates — a relative range like "Last month" would make
  // the agent guess a boundary.
  startDate: string;
  endDate: string;
  // Already human-readable, e.g. "Regions are West" (getDrillDownDescription).
  filterDescriptions: string[];
}): string => {
  const clauses: string[] = [];

  clauses.push(
    chartTitle ? `I'm looking at "${chartTitle}"` : `I'm looking at a chart`,
  );
  if (breakdownLabel) {
    clauses.push(`broken down by ${breakdownLabel}`);
  }
  if (trendInterval) {
    clauses.push(`by ${trendInterval}`);
  }
  clauses.push(`from ${startDate} to ${endDate}`);
  // Omit the clause entirely when there's nothing to say — "filtered to none"
  // reads as a mistake.
  if (filterDescriptions.length > 0) {
    clauses.push(`filtered to ${filterDescriptions.join(' and ')}`);
  }

  return `${clauses.join(', ')}. What stands out in this view, and what's driving it?`;
};

export default buildAskAboutViewQuestion;
